import React, { Component } from 'react'
import { connect } from 'react-redux'
import {  } from '../actions'
import { ReactComponent as CaptureCallIcon } from '../build/images/capture-call.svg'

 class CaptureCallModal extends Component {
        constructor(props) {
            super(props);
            this.state = {visible: '', textInput: ''};
        }


render(){

    return(  
        <div className="modal micromodal-slide" id="modal__capture-fail" aria-hidden="true" role="dialog">
        <div className="modal__overlay" tabIndex="-1">
          <div className="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal__bloqueio__title">
            <main className="modal__content modal__content--small" id="modal__bloqueio__content">
      
              <div className="modal__content__user-details__content">
                <form action="" className="modal__content__form">
      
                  <div className="modal__content__form__group modal__content__form__group--col-8">
                    <div className="modal__content">
      
                      <div className="modal__content__img">
                        <CaptureCallIcon />
                      </div>
      
                      <h3 className="modal-box__warning is-poppins">Não foi possível capturar uma chamada</h3>
      
                      
                      <div className="modal__content__reason-bloq">Nenhuma chamada de grupo disponível para ser capturada nesse momento.</div>
      
      
      
                      <a className="modal__content__form__group__button " aria-label="Close modal" data-micromodal-close>Ok</a>
      
                    </div>
      
                  </div>
      
      
                </form>
              </div>
            </main>
          </div>
        </div>
      </div>
)}
}

export default connect(
    null,
    null
  )(CaptureCallModal);